
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actuary/courses",
      function () {
        return require("private-next-pages/actuary/courses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actuary/courses"])
      });
    }
  